import { Icon } from '@loadsmart/miranda-react'

import {
  StyledSearchField,
  StyledSpacer,
  StyledTab,
  StyledTabCount,
  StyledTabList,
  StyledToolbar,
  StyledVisuallyHidden,
} from './LibraryToolbar.styles'

export const ALL_REPORTS_TAB = 'all'

export type LibraryTab = {
  // Either ALL_REPORTS_TAB or a library category label.
  id: string
  label: string
  count: number
}

type LibraryToolbarProps = {
  tabs: Array<LibraryTab>
  activeTab: string
  onTabChange: (tab: string) => void
  searchQuery: string
  onSearchChange: (query: string) => void
}

export default function LibraryToolbar({
  tabs,
  activeTab,
  onTabChange,
  searchQuery,
  onSearchChange,
}: LibraryToolbarProps) {
  return (
    <StyledToolbar>
      {/* Callers pass no tabs when the catalog is a single ungrouped list. */}
      {tabs.length > 0 && (
        <StyledTabList role="tablist" aria-label="Report products">
          {tabs.map(tab => {
            const isActive = tab.id === activeTab

            return (
              <StyledTab
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={isActive}
                aria-controls="report-list"
                $active={isActive}
                onClick={() => onTabChange(tab.id)}
              >
                {tab.label}
                <StyledTabCount $active={isActive}>{tab.count}</StyledTabCount>
              </StyledTab>
            )
          })}
        </StyledTabList>
      )}

      <StyledSpacer />

      <StyledVisuallyHidden id="library-search-label">Search reports</StyledVisuallyHidden>
      <StyledSearchField
        aria-labelledby="library-search-label"
        /*
          Deliberately not type="search": that adds the browser's own clear
          button on top of the `clearable` one, so the field ends up with two.
        */
        type="text"
        placeholder="Search reports"
        leading={<Icon name="search" />}
        clearable
        value={searchQuery}
        /*
          Miranda's text field re-emits `input` on every keystroke but only
          emits `change` on blur, so the list has to follow `input` to filter
          as you type. Clearing emits neither — it emits `clear`.
        */
        onInput={event => onSearchChange(String(event.target.value ?? ''))}
        onClear={() => onSearchChange('')}
      />
    </StyledToolbar>
  )
}
